import { gql } from '__generated__';

export default gql(`
  query GetParticipantFieldImportDetails($project_id: ID!, $participant_field_import_id: ID!) {
    project(id: $project_id) {
      id
      default_export_columns(type: "registrations") {
        id
        title
      }
      participant_field_import(id: $participant_field_import_id) {
        id
        field {
          id
          scope
          products {
            id
          }
        }
        filename
        columns
        unique_column
        length
        parsed {
          index
          row
          errors {
            column
            errors
          }
        }
        errors {
          index
          row
          errors {
            column
            errors
          }
        }
        errors_count
        existing_rows_count
        preview_url
        ready_to_import
        validated_at
        importing
        imported_at
        confirmation_mail_recipients_count
        confirmation_mail_sent_at
        confirmation_mail_sending
      }
    }
  }
`);
